module.exports = __webpack_public_path__ + "static/media/rollingBridge02.8a432ed4.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/svg/rollingBridge02.svg
// module id = 590
// module chunks = 19